import { render, staticRenderFns } from "./TitleDetailV1.vue?vue&type=template&id=67096784&scoped=true"
import script from "./TitleDetailV1.vue?vue&type=script&lang=ts&setup=true"
export * from "./TitleDetailV1.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TitleDetailV1.vue?vue&type=style&index=0&id=67096784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67096784",
  null
  
)

export default component.exports